"use client"

import {
    Combobox,
    Portal,
    useFilter,
    useListCollection,
} from "@chakra-ui/react"

import { useState, useEffect, useRef } from "react"
import BankList from "./BankList"
const Bank = (props) => {
    const { contains } = useFilter({ sensitivity: "base" })
    const { value, onChange, name } = props;
    console.log("props", props)
    const [open, setOpen] = useState(false)
    const input = useRef();
    const { collection, filter } = useListCollection({
        initialItems: BankList.map(x => {
            return {
                label: x.name,
                value: x.bank_bin
            }
        }),
        filter: contains,
    })

    useEffect(() => {
        // filter("");
        if (input.current) {
            if (open)
                input.current.value = ""
        }
        filter("")

    }, [open])

    return (
        <Combobox.Root
            collection={collection}
            openOnClick
            onInputValueChange={(e) => filter(e.inputValue)}
            width="100%"
            value={[value]}
            open={open}
            onOpenChange={(e) => setOpen(e.open)}
            onValueChange={(e) => {
             onChange({ target: { name: name, value: e.value[0] } });
            }}
        >

            <Combobox.Control>
                <Combobox.Input placeholder="Tìm kiếm" ref={input} />
                <Combobox.IndicatorGroup>
                    <Combobox.ClearTrigger />
                    <Combobox.Trigger />
                </Combobox.IndicatorGroup>
            </Combobox.Control>
            <Portal>
                <Combobox.Positioner>
                    <Combobox.Content>
                        <Combobox.Empty>No items found</Combobox.Empty>
                        {collection.items.map((item) => (
                            <Combobox.Item item={item} key={item.value}>
                                {item.label}
                                <Combobox.ItemIndicator />
                            </Combobox.Item>
                        ))}
                    </Combobox.Content>
                </Combobox.Positioner>
            </Portal>
        </Combobox.Root>
    )
}


export default Bank